import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `https://ui79f5c62g.execute-api.us-west-2.amazonaws.com/dev/email/send`,
  headers: {
    'Content-Type': 'application/json'
  }
})
